import React from 'react'
import ContactUsForm from './PopUpData'

const PopUp = ({ handleClose, show }) => {
    const showHideClassName = show ? 'popup' : 'popup display-none';
    return (
        <>
            <div className='container'>
                <div className={showHideClassName} >
                    <section className="popup-main" style={{ textAlign: 'center', justifyContent: 'center', borderRadius: '10px', backgroundColor: "#f9f9f9" }}>
                        <h4 style={{ textAlign: "center", color: 'rgb(151 151 151)' }}>Stuck in Your Business? Enroll Now !!!!</h4>
                        <div className='d-flex' style={{ textAlign: 'center' }}>
                            <button onClick={handleClose} style={{ position: 'fixed', right: '0', top: '0', marginTop: '11px', backgroundColor: '#f9f9f9' }}>
                                <img src="https://icons.veryicon.com/png/o/miscellaneous/medium-thin-linear-icon/cross-23.png" width={"20px"} height={"20px"} alt="cross" />
                            </button>
                        </div>
                        <h2 style={{ marginTop: "15px", color: 'rgb(13 92 126)' }}>Virtual CEO Program</h2>
                        <h4 style={{ marginTop: '20px' }}>And Transform Yourself Into</h4>
                        <h4>The CEO of Your Busines</h4>
                        <a href="/ContactUs">
                            <button type="button" style={{ backgroundColor: 'rgb(13 92 126)', marginTop: '20px', border: '1px solid rgb(13 92 126)', fontSize: '18px' }} class="btn btn-primary">Register Now</button>
                        </a>
                        <h4 style={{ marginTop: '15px' }}>Join 4 Hour Masterclass + QnA session</h4>
                    </section>
                </div>
            </div>
        </>
    )
}

export default PopUp